module.exports = __webpack_public_path__ + "img/header.50923e2d.png";